/* =========================================================
   HERA — HEADER
   hera-header.js
   ========================================================= */

(function () {

  'use strict';


  function initHeraHeader(header) {

    if (!header) return;
    if (header.dataset.heraInitialized === 'true') return;
    header.dataset.heraInitialized = 'true';


    /* =====================================================
       ÉLÉMENTS
       ===================================================== */

    var progress      = header.querySelector('[data-hera-progress]');
    var fill          = header.querySelector('[data-hera-progress-fill]');
    var indicator     = header.querySelector('[data-hera-progress-indicator]');
    var steps         = Array.from(header.querySelectorAll('[data-step]'));
    var mobileCurrent = header.querySelector('[data-hera-mobile-current]');
    var burger        = header.querySelector('[data-hera-menu-toggle]');
    var megaMenu      = header.querySelector('[data-hera-mega-menu]');
    var closeButton   = header.querySelector('[data-hera-menu-close]');


    /* =====================================================
       ÉTAT
       ===================================================== */

    var menuIsOpen = false;
    var scrollContainer = null;


    /* =====================================================
       DÉTECTION DU CONTENEUR DE SCROLL
       
       Certains thèmes Shopify scrollent sur un <main>,
       un <div class="content-for-layout">, ou un autre
       wrapper au lieu de <body> / window.
       On détecte automatiquement lequel.
       ===================================================== */

    function findScrollContainer() {

      /* Candidats classiques des thèmes Shopify */
      var selectors = [
        'main',
        '#MainContent',
        '#main',
        '.content-for-layout',
        '#shopify-section-main',
        '[role="main"]',
        '#main-content',
        '.main-content'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.scrollHeight > el.clientHeight + 10) {
          /* Vérifier qu'il est réellement scrollable */
          var style = window.getComputedStyle(el);
          var overflow = style.overflowY || style.overflow;
          if (
            overflow === 'auto' ||
            overflow === 'scroll' ||
            overflow === 'overlay'
          ) {
            return el;
          }
        }
      }

      return null;
    }


    /* =====================================================
       SCROLL TOP — MULTI-SOURCE
       ===================================================== */

    function getScrollTop() {

      var val = Math.max(
        window.scrollY || 0,
        window.pageYOffset || 0,
        document.documentElement.scrollTop || 0,
        document.body.scrollTop || 0
      );

      if (scrollContainer) {
        val = Math.max(val, scrollContainer.scrollTop || 0);
      }

      return val;
    }


    /* =====================================================
       POURCENTAGE DE SCROLL
       ===================================================== */

    function getScrollPercentage() {

      /* Si on a un conteneur custom, utiliser ses dimensions */
      if (scrollContainer && scrollContainer.scrollTop > 0) {
        var cHeight = scrollContainer.scrollHeight || 0;
        var cView   = scrollContainer.clientHeight || 0;
        var cAvail  = cHeight - cView;
        if (cAvail > 0) {
          return Math.max(0, Math.min(1, scrollContainer.scrollTop / cAvail));
        }
      }

      /* Sinon, calcul classique */
      var scrollTop = getScrollTop();

      var viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight || 0;

      var html = document.documentElement;
      var body = document.body;

      var documentHeight = Math.max(
        html.scrollHeight, html.offsetHeight, html.clientHeight,
        body ? body.scrollHeight : 0,
        body ? body.offsetHeight : 0,
        body ? body.clientHeight  : 0
      );

      var availableScroll = Math.max(documentHeight - viewportHeight, 0);

      if (availableScroll <= 0) return 0;

      return Math.max(0, Math.min(1, scrollTop / availableScroll));
    }


    /* =====================================================
       ÉTAPE COURANTE
       ===================================================== */

    function getCurrentStep(percentage) {
      if (percentage >= 0.75) return 3;
      if (percentage >= 0.50) return 2;
      if (percentage >= 0.25) return 1;
      return 0;
    }


    /* =====================================================
       MISE À JOUR DES ÉTAPES
       ===================================================== */

    function updateSteps(currentStep) {

      steps.forEach(function (step, index) {
        step.classList.toggle('is-active',    index === currentStep);
        step.classList.toggle('is-completed', index < currentStep);
      });

      if (mobileCurrent && steps[currentStep]) {
        mobileCurrent.textContent =
          steps[currentStep].textContent.replace(/\s+/g, ' ').trim();
      }
    }


    /* =====================================================
       MISE À JOUR DE LA JAUGE
       ===================================================== */

    function updateProgress() {

      if (!progress || !fill || !indicator) return;

      var scrollTop  = getScrollTop();
      var percentage = getScrollPercentage();
      var value      = percentage * 100;

      /* Visibilité */
      if (scrollTop > 2) {
        progress.classList.add('is-visible');
      } else {
        progress.classList.remove('is-visible');
      }

      /* Remplissage */
      fill.style.width = value + '%';

      /* Indicateur */
      indicator.style.left = value + '%';

      /* Étape */
      updateSteps(getCurrentStep(percentage));
    }


    /* =====================================================
       ÉCOUTE DU SCROLL — CAPTURE SUR DOCUMENT
       
       En mode capture (3e argument = true), cet écouteur
       intercepte le scroll sur N'IMPORTE QUEL élément,
       pas seulement window. Ça règle le problème des
       thèmes qui scrollent sur un conteneur interne.
       ===================================================== */

    document.addEventListener('scroll', function (event) {

      /* Détecter le conteneur de scroll au premier événement */
      if (
        !scrollContainer &&
        event.target !== document &&
        event.target !== document.documentElement &&
        event.target.scrollTop > 0
      ) {
        scrollContainer = event.target;
      }

      requestAnimationFrame(updateProgress);

    }, true);


    /* =====================================================
       FALLBACK — AUSSI SUR WINDOW (pour les thèmes normaux)
       ===================================================== */

    window.addEventListener('scroll', function () {
      requestAnimationFrame(updateProgress);
    }, { passive: true });


    /* =====================================================
       FALLBACK 2 — BOUCLE rAF
       Au cas où ni le capture ni window ne fonctionnent
       ===================================================== */

    var lastCheck = -1;

    function pollScroll() {
      var current = getScrollTop();
      if (current !== lastCheck) {
        lastCheck = current;
        updateProgress();
      }
      requestAnimationFrame(pollScroll);
    }

    requestAnimationFrame(pollScroll);


    /* =====================================================
       RESIZE
       ===================================================== */

    window.addEventListener('resize', function () {
      lastCheck = -1;
      scrollContainer = null;
      setTimeout(function () {
        scrollContainer = findScrollContainer();
        updateProgress();
      }, 100);
    });


    /* =====================================================
       MENU — OUVRIR
       ===================================================== */

    function openMenu() {
      if (menuIsOpen) return;
      menuIsOpen = true;
      header.classList.add('is-menu-open');
      if (burger) {
        burger.setAttribute('aria-expanded', 'true');
        burger.setAttribute('aria-label', 'Fermer le menu');
      }
      if (megaMenu) {
        megaMenu.setAttribute('aria-hidden', 'false');
      }
      document.documentElement.classList.add('hera-menu-lock');
      document.body.classList.add('hera-menu-open');
    }


    /* =====================================================
       MENU — FERMER
       ===================================================== */

    function closeMenu() {
      if (!menuIsOpen) return;
      menuIsOpen = false;
      header.classList.remove('is-menu-open');
      if (burger) {
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', 'Ouvrir le menu');
      }
      if (megaMenu) {
        megaMenu.setAttribute('aria-hidden', 'true');
      }
      document.documentElement.classList.remove('hera-menu-lock');
      document.body.classList.remove('hera-menu-open');
    }


    /* =====================================================
       TOGGLE / BURGER / CLOSE / ESC / LIENS
       ===================================================== */

    if (burger) {
      burger.addEventListener('click', function (e) {
        e.preventDefault();
        menuIsOpen ? closeMenu() : openMenu();
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', function (e) {
        e.preventDefault();
        closeMenu();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menuIsOpen) closeMenu();
    });

    if (megaMenu) {
      megaMenu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
    }


    /* =====================================================
       INIT — Détecter le conteneur + première mise à jour
       ===================================================== */

    scrollContainer = findScrollContainer();
    updateProgress();

  }


  /* =========================================================
     INITIALISER TOUS LES HEADERS
     ========================================================= */

  function initAllHeraHeaders() {
    document.querySelectorAll('[data-hera-header]').forEach(function (header) {
      initHeraHeader(header);
    });
  }


  /* =========================================================
     DOM READY
     ========================================================= */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHeraHeaders);
  } else {
    initAllHeraHeaders();
  }


  /* =========================================================
     SHOPIFY EVENTS
     ========================================================= */

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section || !section.querySelector) return;
    var h = section.querySelector('[data-hera-header]');
    if (h) {
      h.dataset.heraInitialized = 'false';
      initHeraHeader(h);
    }
  });

  document.addEventListener('shopify:section:reorder', initAllHeraHeaders);

  document.addEventListener('shopify:section:select', function (event) {
    var section = event.target;
    if (section && section.querySelector) {
      var h = section.querySelector('[data-hera-header]');
      if (h) {
        var p = h.querySelector('[data-hera-progress]');
        if (p) p.classList.remove('is-visible');
      }
    }
  });

  window.addEventListener('pageshow', function () {
    document.documentElement.classList.remove('hera-menu-lock');
    document.body.classList.remove('hera-menu-open');
  });

})();